const $inject = ['$q', '$timeout', 'dataService'];

const pointsOfInterestService = function ($q, $timeout, dataService) {
  var service = {};

  service.savePointOfInterest = savePointOfInterest;
  service.deletePointOfInterest = deletePointOfInterest;

  function deletePointOfInterest(item) {
    let deferred = $q.defer();

    dataService
      .delete('PointOfInterests', item.id)
      .then(() => { deferred.resolve({ message: 'done' }); })
      .catch(data => { deferred.reject(data); });

    return deferred.promise;
  }

  function savePointOfInterest(debtor, item) {
    let deferred = $q.defer();
    let itemCopy = {};

    item.DebtorIdentifier = item.DebtorIdentifier || debtor;
    item.Type = item.Type || "PointOfInterest";

    item.Longitude = parseFloat(item.Longitude);
    item.Latitude = parseFloat(item.Latitude);

    item.Location = {
      coordinates: [item.Longitude, item.Latitude],
      type: "Point"
    };

    angular.copy(item, itemCopy);

    const id = itemCopy.Id || itemCopy.id;

    delete itemCopy.marker;
    delete itemCopy.active;

     // Do not send identity/system fields in create/update payloads.
    delete itemCopy.Id;
    delete itemCopy.id;
    delete itemCopy.CreatedBy;
    delete itemCopy.CreatedOn;
    delete itemCopy.ModifiedBy;
    delete itemCopy.ModifiedOn;
    delete itemCopy.ETag;
    delete itemCopy._etag;
    delete itemCopy.PartitionKey;
    delete itemCopy._partitionKey;

    const request = id ? dataService.patch('PointOfInterests', itemCopy, id) : dataService.post('PointOfInterests', itemCopy);

    request
      .then(data => { deferred.resolve(data); })
      .catch(data => { deferred.reject(data); });

    return deferred.promise;
  }

  return service;
};

pointsOfInterestService.$inject = $inject;

export default pointsOfInterestService;



// WEBPACK FOOTER //
// ./src/services/pointsOfInterestService.js